<template>
    <div>
        <div class="table-responsive">
            <datatable
                :columns="columnsFormated"
                :data="itens"
                class="table table-hover"
            >
                <template slot="no-results">
                  <EmptyState
                    icon="search"
                    title="Nenhum resultado encontrado"
                    description="Não há registros cadastrados ou nenhum resultado corresponde à busca realizada."
                  />
                </template>
                <template slot-scope="{ row }">
                    <tr v-bind:class="{ registroInvalidado: row._invalidado }">
                        <td v-for="column in columnsFormated">
                            <slot
                              v-if="column.useSlot"
                              :name="column.field"
                              :model="row"
                            />
                            <template v-else-if="isKeyValue(row, column)">
                              <KeyValueTable :dataObject="row[column.field]" />
                            </template>
                            <template v-else-if="column.representedAs">
                                {{ column.representedAs(row) }}
                            </template>
                            <template v-else-if="column.field">
                                {{ row[column.field] }}
                            </template>
                            <template v-else>
                                <div class="text-right actions">
                                    <slot
                                        name="action-buttons"
                                        :model="row"
                                    />
                                    <CButton
                                        v-if="onUpdate != null"
                                        size="sm"
                                        color="primary"
                                        :disabled="typeof canUpdate === 'function' ? !canUpdate(row) : false"
                                        @click="onUpdate(row)"
                                        title="Alterar"
                                    >
                                        <fa-icon icon="pencil-alt" />
                                    </CButton>
                                    <CButton
                                        v-if="onDelete != null"
                                        size="sm"
                                        :disabled="typeof canDelete === 'function' ? !canDelete(row) : false"
                                        @click="onDelete(row)"
                                        color="danger"
                                        title="Excluir"
                                    >
                                        <fa-icon icon="trash-alt" />
                                    </CButton>
                                    <CButton
                                        v-if="onShow != null"
                                        size="sm"
                                        @click="onShow(row)"
                                        color="info"
                                        title="Visualizar"
                                    >
                                        <fa-icon icon="info-circle" />
                                    </CButton>
                                    <CButton
                                        v-if="onClone != null"
                                        size="sm"
                                        @click="onClone(row)"
                                        color="secondary"
                                        title="Duplicar"
                                    >
                                        <fa-icon icon="clone" />
                                    </CButton>
                                    <slot
                                        name="action-buttons-after"
                                        :model="row"
                                    />
                                </div>
                            </template>
                        </td>
                    </tr>
                </template>
            </datatable>
            <Loading
              :is-active="isLoadingData"
              :message="'Carregando informações'"
              :is-absolute="true"
            />
        </div>
        <pagination
            :data="paginator"
            :limit="2"
            @pagination-change-page="onPageChange"
        />
    </div>
</template>

<script>
  import clone from 'just-clone';
  import KeyValueTable from './KeyValueTable';
  import EmptyState from '../EmptyState';
  import _isObject from "lodash/isObject";

  export default {
    name: "TablePaginated",
    components: {
      KeyValueTable,
      EmptyState,
    },
    props: [
      'columns',
      'itens',
      'paginator',
      'canDelete',
      'onDelete',
      'canUpdate',
      'onUpdate',
      'onShow',
      'onClone',
      'onPageChange',
      'isLoadingData',
      'showActions',
    ],
    computed: {
      columnsFormated() {
        let rawColumns = clone(this.columns);

        if (this.onDelete || this.onUpdate || this.onShow || this.showActions) {
          rawColumns.push({ label: '#', sortable: false, })
        }

        return rawColumns;
      }
    },
    methods: {
      isKeyValue(row, column) {
        return column.isKeyValue && _isObject(row[column.field])
      }
    }
  }
</script>

<style scoped>
  /*.action-buttons * {*/
  /*  margin-left: 4px;*/
  /*}*/
</style>